module.exports = __webpack_public_path__ + "img/maria-jose-garcia-byn.0aa50f3c.png";